import { render, staticRenderFns } from "./typeDBtn.vue?vue&type=template&id=7651ac54"
import script from "./typeDBtn.vue?vue&type=script&lang=js"
export * from "./typeDBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports